module.exports = __webpack_public_path__ + "img/logo-lorene-principal.66101c54.png";